import { type Dispatch, useContext } from 'react';

import { SessionDispatchContext, SessionStateContext } from './sessionContext';
import { type Action, type SessionState } from './types';

export function useSessionState(): SessionState {
  const state = useContext(SessionStateContext);
  if (state === null) throw new Error('useSessionState outside SessionProvider');
  return state;
}

export function useSessionDispatch(): Dispatch<Action> {
  const dispatch = useContext(SessionDispatchContext);
  if (dispatch === null) throw new Error('useSessionDispatch outside SessionProvider');
  return dispatch;
}
